module.exports = __webpack_public_path__ + "img/jm.a1da9686.svg";